var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissionsFreeBusy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 1.33398V4.00065M5.33398 1.33398V4.00065",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 1.33398V4.00065M5.33398 1.33398V4.00065",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 7.16413C13.999 7.21174 13.9992 7.25988 13.9993 7.30857L13.9987 7.16413ZM13.9987 7.16413C13.9892 5.19643 13.9082 4.13637 13.2189 3.44706C12.4379 2.66602 11.1808 2.66602 8.66667 2.66602H7.33333C4.81917 2.66602 3.5621 2.66602 2.78105 3.44706C2 4.22812 2 5.48519 2 7.99935V9.33268C2 11.8468 2 13.1039 2.78105 13.8849C3.40977 14.5137 4.34695 14.6363 6 14.6602H7",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 7.16413C13.999 7.21174 13.9992 7.25988 13.9993 7.30857L13.9987 7.16413ZM13.9987 7.16413C13.9892 5.19643 13.9082 4.13637 13.2189 3.44706C12.4379 2.66602 11.1808 2.66602 8.66667 2.66602H7.33333C4.81917 2.66602 3.5621 2.66602 2.78105 3.44706C2 4.22812 2 5.48519 2 7.99935V9.33268C2 11.8468 2 13.1039 2.78105 13.8849C3.40977 14.5137 4.34695 14.6363 6 14.6602H7",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.66602H14",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.66602H14",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2404 11.2935L11.2403 10.289C11.2403 10.1406 11.2464 9.99043 11.299 9.85187C11.4391 9.48315 11.8101 9 12.4855 9C13.1608 9 13.5464 9.48315 13.6864 9.85187C13.739 9.99043 13.7451 10.1406 13.7451 10.289V11.2935M11.29 15.5H13.71C14.4224 15.5 15 14.9173 15 14.1985V12.7527C15 12.0339 14.4224 11.4512 13.71 11.4512H11.29C10.5776 11.4512 10 12.0339 10 12.7527V14.1985C10 14.9173 10.5776 15.5 11.29 15.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2404 11.2935L11.2403 10.289C11.2403 10.1406 11.2464 9.99043 11.299 9.85187C11.4391 9.48315 11.8101 9 12.4855 9C13.1608 9 13.5464 9.48315 13.6864 9.85187C13.739 9.99043 13.7451 10.1406 13.7451 10.289V11.2935M11.29 15.5H13.71C14.4224 15.5 15 14.9173 15 14.1985V12.7527C15 12.0339 14.4224 11.4512 13.71 11.4512H11.29C10.5776 11.4512 10 12.0339 10 12.7527V14.1985C10 14.9173 10.5776 15.5 11.29 15.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionsFreeBusy);
export default __webpack_public_path__ + "static/media/permissions_free_busy.8e6b37e786b7c413f6b86c4953d75bb3.svg";
export { ForwardRef as ReactComponent };